import { API, Storage } from 'aws-amplify';

function cleanEmptyValue(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '') {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  });

  return obj;
}

export const create = async event => API.put('cmseinkaufskreisApi', '/events', { body: cleanEmptyValue(event) });

export const read = async () => API.get('cmseinkaufskreisApi', '/events', {});

export const update = async event => API.post('cmseinkaufskreisApi', '/events', { body: cleanEmptyValue(event) });

export const del = async event => API.del('cmseinkaufskreisApi', `/events/${event.id}`, {});

// eslint-disable-next-line max-len
export const uploadEventTitleImage = async (title, image) => Storage.put(`public/event/${title}`, image, { contentType: image.type });

// eslint-disable-next-line max-len
export const uploadEventGalleryImage = async (title, event, image) => Storage.put(`public/event/${event.id}/${title}`, image, { contentType: image.type });
